import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultErrorPageComponent } from '../default-error-page/default-error-page.component';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { ErrorCustomerComponent } from '../error-customer/error-customer.component';
import { LocalePlaceholderDirective } from './directives/localeplaceholder.directive';
import { LocaleByKeyPipe, ReplaceStringPipe } from './localePipe';
import { AppInsightsService } from './services/appinsights/appinsights.service';
import { FeaturesService } from './services/Features/features.service';
import { LocaleComponent } from './templates/Locale/locale.component';
import { ConfigService, LocalesService } from './templates/Locale/locales.service';
import { RequiredComponent } from './templates/required/required.component';
import { SpinnerComponent } from './templates/spinner/spinner.component';
import { SpinnerService } from './templates/spinner/spinner.service';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { LocaleModule } from './templates/Locale/locale.module';
import { DismissAlertComponent } from './templates/dismiss-alert/dismiss-alert.component';
import { LanguageService } from '../shared/services/language/language.service';
import { ErrorMaintenanceComponent } from '../error-maintenance/error-maintenance.component';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { ScreenReaderRequiredComponent } from './templates/required/screen-reader.required.component';


@NgModule({ declarations: [
        RequiredComponent,
        ScreenReaderRequiredComponent,
        SpinnerComponent,
        ErrorPageComponent,
        ErrorCustomerComponent,
        DefaultErrorPageComponent,
        DismissAlertComponent,
        ErrorMaintenanceComponent,
        PhoneMaskDirective
    ],
    exports: [
        RequiredComponent,
        ScreenReaderRequiredComponent,
        SpinnerComponent,
        ErrorPageComponent,
        ErrorCustomerComponent,
        DefaultErrorPageComponent,
        ReactiveFormsModule,
        MatDialogModule,
        RouterModule,
        DismissAlertComponent,
        ErrorMaintenanceComponent,
        PhoneMaskDirective
    ], imports: [CommonModule,
        ReactiveFormsModule,
        RouterModule,
        MatDialogModule,
        LocaleModule], providers: [
        FeaturesService,
        SpinnerService,
        AppInsightsService,
        ConfigService,
        LanguageService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SharedModule { }
